module.exports = __webpack_public_path__ + "img/level_six_lock.354aa91e.png";